import React, { useState } from "react";
import image1 from "../images/sample-section-img/sample-1.png";
import image2 from "../images/sample-section-img/sample-2.png";
import image3 from "../images/sample-section-img/sample-3.png";
import image4 from "../images/sample-section-img/sample-4.png";
import image5 from "../images/sample-section-img/sample-5.png";
import image6 from "../images/sample-section-img/sample-6.png";
import image7 from "../images/sample-section-img/sample-7.png";
import image8 from "../images/sample-section-img/sample-8.png";
import image9 from "../images/sample-section-img/sample-9.png";

import circle from "../icons/circle.png";
import zig from "../icons/zig-zag.png";
import CommonContact from "../ContactPageComponents/CommonContact";

function SampleWebsites() {
  // Array of images
  const images = [image1, image2, image3, image4, image5, image6, image7, image8, image9];
  
  // State to keep track of the current page
  const [currentPage, setCurrentPage] = useState(0);

  // Define images per page: 2 for mobile (default) and 3 for medium screens and above
  const imagesPerPage = window.innerWidth >= 768 ? 3 : 2;

  // Calculate total number of pages
  const totalPages = Math.ceil(images.length / imagesPerPage);

  // Determine the images to display for the current page
  const displayedImages = images.slice(
    currentPage * imagesPerPage,
    (currentPage + 1) * imagesPerPage
  );

  // Function to handle going to the next page
  const nextPage = () => {
    if (currentPage < totalPages - 1) {
      setCurrentPage(currentPage + 1);
    }
  };

  // Function to handle going to the previous page
  const prevPage = () => {
    if (currentPage > 0) {
      setCurrentPage(currentPage - 1);
    }
  };

  // Define the padding values for the images with responsive classes
  const getPaddingTop = (index) => {
    switch (index) {
      case 0:
        return "md:pt-2.5"; // 10px on medium screens and above
      case 1:
        return "md:pt-12"; // 50px on medium screens and above
      case 2:
        return "md:pt-24"; // 100px on medium screens and above
      default:
        return "pt-0"; // No padding by default
    }
  };

  return (
    <div className="h-full mt-20 md:mt-0 md:min-h-screen relative">
      <img src={circle} alt="circle" className="absolute left-3/4" />
      <img src={zig} alt="zig-zag" className="absolute left-40 top-2/4" />
      
      <div className="absolute blur-[150px] rotate-12 top-1/4 left-1/4 w-[700px] h-[100px] bg-gradient-to-r from-[#00c3ffdb] to-[#FF29C3]"></div>
      <div className="flex flex-col items-center justify-center py-16 px-4 h-screen">
        
        {/* Title */}
        <h2 className="text-center text-transparent bg-clip-text bg-gradient-to-r from-[#ff4d97] to-[#ff6ac4] text-5xl font-bold mb-12">
          Our Awesome Websites
        </h2>

        {/* Images Container with Staggered Alignment */}
        <div className="flex flex-wrap justify-center gap-10">
          {displayedImages.map((image, index) => (
            <div key={index} className={`relative ${getPaddingTop(index)}`}>
              <div className="w-[350px] h-[250px] border-[11px] border-gray-500 rounded-lg overflow-hidden">
                <img src={image} alt={`Website ${index + 1}`} className="w-full h-full object-cover" />
              </div>
            </div>
          ))}
        </div>

        {/* Pagination Controls */}
        <div className="flex mt-20 items-center space-x-6">
          {/* Previous Button */}
          <button
            className="w-12 h-12 rounded-full border border-gray-500 flex items-center justify-center bg-transparent hover:bg-pink-500 hover:bg-opacity-20 transition-all duration-300 ease-in-out"
            onClick={prevPage}
            disabled={currentPage === 0}
          >
            <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-pink-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
            </svg>
          </button>

          {/* Pagination Dots */}
          <div className="flex items-center space-x-2">
            {Array.from({ length: totalPages }).map((_, idx) => (
              <span
                key={idx}
                className={`w-3 h-3 rounded-full ${idx === currentPage ? "bg-gradient-to-r from-pink-500 to-purple-500 w-8 h-2" : "bg-gray-500"}`}
              />
            ))}
          </div>

          {/* Next Button */}
          <button
            className="w-12 h-12 rounded-full border border-gray-500 flex items-center justify-center bg-transparent hover:bg-pink-500 hover:bg-opacity-20 transition-all duration-300 ease-in-out"
            onClick={nextPage}
            disabled={currentPage === totalPages - 1}
          >
            <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-pink-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
            </svg>
          </button>
        </div>
      </div>

      {/* Contact Us Section */}
      <CommonContact />
    </div>
  );
}

export default SampleWebsites;
